<template>
  <div class="account-tab-content tab-notifications">
    <TableAccount
            :title="'Notifications'"
            :fields="fields"
            :items="logs"
            :current-page="currentPage"
            :total-rows="rows"
            :per-page="perPage"
            @changePage="handleChangePage"
    />
  </div>
</template>

<script>
import TableAccount from '@/components/common/table/table';
import accountService from '@/services/account.service';

export default {
  components: {
    TableAccount
  },
  data() {
    return {
      logs: null,
      total: 0,
      perPage: 3,
      currentPage: 1,
      fields: [
        {key: 'id', label: 'ID'},
        {key: 'created_at_short', label: 'Date'},
        {key: 'message', label: 'Message'}
      ]
    }
  },
  computed: {
    rows() {
      return this.total
    }
  },
  created() {
    accountService.notifications(this.currentPage).then((res) => {
      if (res) {
        this.logs = res.logs;
        this.total = res.total;
      }
    });
  },
  methods: {
    handleChangePage(val) {
      this.currentPage = val;
      accountService.notifications(this.currentPage).then((res) => {
        if (res) {
          this.logs = res.logs;
        }
      });
    }
  }
}
</script>
